/**
 * Hero Image Content Section
 * Proporciona funcionalidad interactiva para la sección hero con imagen y contenido
 */

class HeroImageContentSection {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.setupResponsive();
    this.setupAccessibility();
    this.setupButtonInteraction();
    window.addEventListener('resize', () => this.setupResponsive());
  }

  /**
   * Configura el comportamiento responsivo
   */
  setupResponsive() {
    const isMobile = window.innerWidth <= 768;
    const container = this.container.querySelector('.hic__container');
    
    if (isMobile) {
      container.style.minHeight = 'auto';
    } else {
      const minHeight = this.container.dataset.minHeight || '500px';
      container.style.minHeight = minHeight;
    }
  }

  /**
   * Mejora la accesibilidad
   */
  setupAccessibility() {
    const title = this.container.querySelector('.hic__title');
    const description = this.container.querySelector('.hic__description');
    const button = this.container.querySelector('.hic__button');

    // Asegurar que el título sea accesible
    if (title && !title.getAttribute('role')) {
      title.setAttribute('role', 'heading');
    }

    // Agregar atributo aria-label al botón si es necesario
    if (button && !button.getAttribute('aria-label')) {
      const buttonText = button.textContent.trim();
      button.setAttribute('aria-label', buttonText);
    }
  }

  /**
   * Agrega interactividad al botón
   */
  setupButtonInteraction() {
    const button = this.container.querySelector('.hic__button');
    
    if (button) {
      button.addEventListener('mouseenter', () => {
        button.style.opacity = '0.9';
      });

      button.addEventListener('mouseleave', () => {
        button.style.opacity = '1';
      });

      // Agregar efecto de ripple en mobile
      button.addEventListener('touchstart', () => {
        button.style.transform = 'scale(0.98)';
      });

      button.addEventListener('touchend', () => {
        button.style.transform = 'scale(1)';
      });
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  const heroContainers = document.querySelectorAll('[data-hero-image-content]');
  heroContainers.forEach(container => {
    new HeroImageContentSection(container);
  });
});

// Para Shopify Theme Editor
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.detail.target;
    if (section.querySelector('[data-hero-image-content]')) {
      new HeroImageContentSection(section.querySelector('[data-hero-image-content]'));
    }
  });
}
